import { IItemProperty, IInformation } from '../types/ItemProperty';
import { IRootState } from '@/store/types/IRootState';

const itemMutations = {
  populateitemsState(state: IRootState, responseProducts: any) {
    state.items = responseProducts.map((product: any) => {
      return {
        id: product.Id,
        code: product.Codigo,
        code2: product.Codigo2,
        validName: product.NomeValido,
        name: product.Nome,
        family: product.Familia,
        productInformation: mapProductInformation(product),
        categorias:  product.Categorias,
        classFiscal: product.ClassFiscal,
        empresas: product.Empresas,
        idPadrao: product.IdPadrao,
        status: product.Status,
        statusERP: product.StatusERP,
        statusSaneamento: product.StatusSaneamento,
        tipo: product.Tipo,
        unidadeMedida: product.UnidadeMedida,
        origem: product.Origem,
        partNumbers: getPartNumbers(product.PartNumbers),
        isNumeric: false,
        midias: product.Midias,
        };
      });
  },
  setItemsCounter(state: IRootState, elasticSearchResponseCount: number) {
    state.itemsCounter = elasticSearchResponseCount;
  },
  clearItems(state: IRootState) {
    state.items = [];
  },
  hasEmptySearchResponse(state: IRootState, hasEmptySearchResponse: boolean) {
    state.hasEmptySearchResponse = hasEmptySearchResponse;
  },
  setPreviewImage(state: IRootState, url: string) {
    state.previewUrl = url;
  },
};

export default itemMutations;
function getPartNumbers(partNumber: any) {
  return partNumber.map((pnbr: any) => {
    const  pnName = Object.keys(pnbr)[0];
    return {
    name: pnName,
    value: pnbr[pnName],
    };
  });
}

function mapProductInformation(product: any): IInformation[] {
  const productInformationEn = {
    language: 'en',
    description: product.DescricaoEn,
    attributes: mapItemAttributes(product.AttributosEn),
  };
  const productInformationPt = {
    language: 'pt',
    description: product.DescricaoPt,
    attributes: mapItemAttributes(product.AttributosPt),
  };
  const productInformationEs = {
    language: 'es',
    description: product.DescricaoEs,
    attributes: mapItemAttributes(product.AttributosEs),
  };
  return [productInformationEn, productInformationPt, productInformationEs];
}

function mapItemAttributes(attribute: any) {
  return attribute.map((attr: any) => {
    const attrName = Object.keys(attr)[0];
    return {
      name: attrName,
      uid: attrName.split(' ').join('_'),
      value: attr[attrName],
      UOM: attr[1],
    };
  });
}
